<template>
  <div style="display: flex;">
    <ValidationProvider name="Date" :rules="{ checkDate: toDate }" v-slot="{ errors }">
      <CalendarInput :hasValidators="hasValidators" :label="$t('FechaDesde')" :maxDate="toDate" :dateFromCurrent="dateFromCurrent" v-model="fromDate" style="padding-right: 1rem;"></CalendarInput>
      <p class="text-danger" style="width:300px">{{ errors[0] }}</p>
    </ValidationProvider>
    <CalendarInput :hasValidators="hasValidators" :label="$t('FechaHasta')" :minDate="fromDate" v-model="toDate" style="padding-left: 1rem;"></CalendarInput>
  </div>
</template>
<script>
import CalendarInput from '../calendar-input/CalendarInput.vue';
export default {
  components: {
    CalendarInput
  },

  name: 'CalendarRangeInput',

  props: {
    value: {
      type: Object,
      required: true
    },
    dateFromCurrent: {
      type: Boolean,
      required: false,
      default: true
    },
    hasValidators : {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      fromDate: this.value.fromDate,
      toDate: this.value.toDate
    };
  },

  watch: {
    fromDate (fromDate) {
      this.fromDate = fromDate;
      this.$emit('input', {fromDate: this.fromDate, toDate: this.toDate})
    },
    toDate (toDate) {
      this.toDate = toDate;
      this.$emit('input', {fromDate: this.fromDate, toDate: this.toDate})
    }
  },

};
</script>
<style></style>
